import {format} from "date-fns";

export const formatTime = (datetime, showSeconds = false, unixTime = false) => {
    if (datetime !== undefined)
        if (datetime && !unixTime) {
            const timeForm = showSeconds ? 'HH:mm:ss' : 'HH:mm';
            return format(new Date(datetime), timeForm);
        } else if (unixTime)
            return new Date(datetime * 1e3 + 60 * 60 * 1e3).toISOString().slice(-13, -8);
}

export default formatTime;